import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";

const INTRO_IMAGE = "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/gmngv9hf_AU20AC-OpenC-Day01-Am-18-768x549-1.jpg";

const IntroSection = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIsVisible(true),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="intro" ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div
            className={`transition-all duration-700 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a2e] mb-6">
              {t("intro.title")}
            </h2>
            <p className="text-xl font-bold text-[#1a1a2e] leading-relaxed mb-6">
              {t("intro.mainText")}
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-4">
              {t("intro.description")}
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-4">
              {t("intro.additionalText")}
            </p>
            <p className="text-gray-600 text-base leading-relaxed">
              {t("intro.contextText")}
            </p>
          </div>

          <div
            className={`rounded-xl overflow-hidden transition-all duration-700 delay-300 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <img
              src={INTRO_IMAGE}
              alt={t("intro.title")}
              className="w-full h-full min-h-[400px] object-cover rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
